module.exports = __webpack_public_path__ + "static/media/pdfIcon.42e6c358.svg";